// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Panel-module__main--TdyMA {
    --panel-horizontal-padding: 20px;
    --panel-vertical-padding: 40px;
    border-radius: 20px;
    background: var(--color-general-white, #fff);

    /* Drop */
    box-shadow: 0px 3px 32px 0px rgba(133, 122, 109, 0.2);

    padding: var(--panel-vertical-padding) 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/dom/components/Panel/Panel.module.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,8BAA8B;IAC9B,mBAAmB;IACnB,4CAA4C;;IAE5C,SAAS;IACT,qDAAqD;;IAErD,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB","sourcesContent":[".main {\n    --panel-horizontal-padding: 20px;\n    --panel-vertical-padding: 40px;\n    border-radius: 20px;\n    background: var(--color-general-white, #fff);\n\n    /* Drop */\n    box-shadow: 0px 3px 32px 0px rgba(133, 122, 109, 0.2);\n\n    padding: var(--panel-vertical-padding) 0;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Panel-module__main--TdyMA`
};
export default ___CSS_LOADER_EXPORT___;
